import { useState } from "react";
import { useStripeConnect } from "../../custom-hooks/useStripeConnect";
import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import { Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { NetworkCalls } from "../../NetworkCalls";

export default function GuestCardOnboarding() {
  const [accountCreatePending, setAccountCreatePending] = useState(false);
  const [onboardingExited, setOnboardingExited] = useState(false);
  const [error, setError] = useState(false);
  const [connectedAccountId, setConnectedAccountId] = useState<string | undefined>();
  const stripeConnectInstance = useStripeConnect(connectedAccountId);

  const handleCreateAccount = async () => {
    setAccountCreatePending(true);
    setError(false);

    try {
      const response = await NetworkCalls.createStripeConnectAccount();
      setAccountCreatePending(false);

      if (response.account) {
        setConnectedAccountId(response.account);
      }
    } catch (err) {
      console.error("Error creating account:", err);
      setAccountCreatePending(false);
      setError(true);
    }
  };

  return (
    <div className="m-5 col row justify-content-center">
      <div className="card border-0">
        <div className="card-header">
          <h1>Stripe Connect Onboarding</h1>
        </div>
        <div className="card-body">
          {!connectedAccountId && (
            <div className="mb-4">
              <h3>Zahlungen für Gastkarten einrichten</h3>
              <p className="text-muted">
                Verbinden Sie Ihr Stripe-Konto, um Zahlungen für Gastkarten zu empfangen.
                Sie werden durch den Onboarding-Prozess geführt, um alle erforderlichen
                Informationen bereitzustellen.
              </p>
            </div>
          )}

          {connectedAccountId && !stripeConnectInstance && (
            <div className="mb-4">
              <h3>Informationen hinzufügen</h3>
              <p className="text-muted">
                Vervollständigen Sie Ihre Kontoinformationen, um Zahlungen zu empfangen.
              </p>
            </div>
          )}

          {!accountCreatePending && !connectedAccountId && (
            <div className="d-flex gap-2">
              <Button
                variant="primary"
                onClick={handleCreateAccount}
                size="lg"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                     viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                     strokeLinecap="round" strokeLinejoin="round"
                     className="icon icon-tabler icons-tabler-outline icon-tabler-plus me-2">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M12 5l0 14"/>
                  <path d="M5 12l14 0"/>
                </svg>
                Einrichtung starten oder fortsetzen
              </Button>
              <Link to="/dashboard/administration/guest-cards" className="btn btn-outline-secondary">
                Zurück zur Übersicht
              </Link>
            </div>
          )}

          {stripeConnectInstance && (
            <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
              <ConnectAccountOnboarding
                onExit={() => setOnboardingExited(true)}
              />
            </ConnectComponentsProvider>
          )}

          {error && (
            <Alert variant="danger" className="mt-3">
              <strong>Fehler!</strong> Beim Erstellen des Kontos ist ein Fehler aufgetreten.
              Bitte versuchen Sie es später erneut.
            </Alert>
          )}

          {(connectedAccountId || accountCreatePending || onboardingExited) && (
            <div className="alert alert-info mt-3">
              {connectedAccountId && (
                <p className="mb-0">
                  <strong>Verbundene Konto-ID:</strong> <code>{connectedAccountId}</code>
                </p>
              )}
              {accountCreatePending && (
                <p className="mb-0">Erstelle verbundenes Konto...</p>
              )}
              {onboardingExited && (
                <div>
                  <p className="mb-2">Das Onboarding wurde beendet.</p>
                  <Link to="/dashboard/administration/guest-cards" className="btn btn-primary">
                    Zurück zur Gastkartenverwaltung
                  </Link>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
